/* import __COLOCATED_TEMPLATE__ from './article-resolution-rate.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { units } from 'embercom/lib/reporting/flexible/formatters';
import { ARTICLE_RESOLVED, ARTICLE_VIEWS } from 'embercom/lib/reporting/csf-queries';
import { getTimeConfig } from 'embercom/lib/reporting/csf-query-helper';
import { buildDataConfigWithComparisons } from '../../../../lib/reporting/comparison-data-config';
import { improvementDirections } from 'embercom/components/reporting/element/summary-comparison';

const ARTICLE_RESOLUTION_RATE_NUMERATOR = 'article-resolution-rate-numerator';
const ARTICLE_RESOLUTION_RATE_DENOMINATOR = 'article-resolution-rate-denominator';

export default class ArticleResolutionRate extends Component {
  @service intercomEventService;

  get viewConfig() {
    return {
      formatUnit: { unit: units.percent },
      counter: {
        [ARTICLE_RESOLUTION_RATE_NUMERATOR]: {
          improvementDirection: improvementDirections.INCREASING,
        },
      },
    };
  }

  get time() {
    return getTimeConfig({ range: this.args.range });
  }

  get dataConfig() {
    return buildDataConfigWithComparisons(
      {
        series: [
          {
            name: ARTICLE_RESOLUTION_RATE_NUMERATOR,
            ...ARTICLE_RESOLVED,
            time: this.time,
          },
          {
            name: ARTICLE_RESOLUTION_RATE_DENOMINATOR,
            ...ARTICLE_VIEWS,
            time: this.time,
          },
        ],
      },
      this.args.range,
    );
  }

  @action
  trackAnalyticsEvent() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'hovered',
      object: 'tooltip',
      context: 'articles_resolution_rate',
    });
  }
}
